export const PRO_LOGIN_TYPE = 'pro';

export const X_APPID = '777';
